import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { photosModerationQuery } from '@/api'
import { PageEditHeader } from '@/components/PageEditHeader'
import PhotosModeration from '@/features/photos/PhotosModeration'
import { useSuspenseQuery } from '@tanstack/react-query'

export const Route = createFileRoute('/photos/')({
  loader: ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData(photosModerationQuery())
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { data } = useSuspenseQuery(photosModerationQuery())

  return (
    <>
      <PageEditHeader title={t('photos.photosModeration')} />

      <PhotosModeration entries={data} />
    </>
  )
}
